<template>
  <!-- 大陆居民基本信息 -->
  <div>
    <div class="tips">
      <p>
        <i class="el-icon-warning" style="color:#FEB304"></i
        >&nbsp;&nbsp;实名认证提示
      </p>
      <p>
        1.《中华人民共和国电子签名法》要求签署方身份真实，个人（企业）身份信息将用来申请数字证书。
      </p>
    </div>
    <div class="info-box">
      <el-form
        ref="cardFace"
        :model="cardFace"
        :rules="faceFrmRules"
        label-width="150px"
        label-position="left"
      >
        <el-form-item label="证件类型：" required>
          <div class="id-type" style="width:20vw">
            <span style="font-weight: bold">身份证</span>
            <!-- <span style="font-size:12px"
              >
              <span style="color:#E3241D;cursor: pointer;" @click="noContinent">
                非中国大陆居民 &gt;
              </span>
            </span> -->
          </div>

          <!--          <el-input value="身份证" readonly></el-input>-->
        </el-form-item>
        <!-- <div class="can-be-show" @click="handleShowUpload">
          {{ `上传身份证照片(${isShow ? "收起" : "展开"})` }}
          <i v-if="isShow" class="el-icon-arrow-down"></i>
          <i v-else class="el-icon-arrow-up"></i>
        </div> -->
        <el-form-item prop="url">
          <div class="card-box">
            <div class="card-face">
              <div class="preview-box" v-if="personalFront.url">
                <img class="avatar" :src="personalFront.url" />
                <div class="img-box">
                  <i
                    style="color:#fff"
                    class="el-icon-delete-solid delete-sty"
                    @click="delBackImg('face')"
                  ></i>
                </div>
              </div>
              <el-upload
                v-if="!personalFront.url"
                action="#"
                :show-file-list="false"
                :on-success="
                  (response, file, fileList) =>
                    handleIdeCareSuccess(
                      response,
                      file,
                      fileList,
                      'personalFront'
                    )
                "
                :before-upload="
                  file => beforeIdeCareUpload(file, 'personalFront')
                "
              >
                <div>
                  <div class="card-item">
                    <i
                      class="el-icon-plus avatar-uploader-icon"
                      style="font-size:3vw;color:#C2C2C2"
                    ></i>
                    <p class="upload-tit">人像面</p>
                  </div>
                </div>
              </el-upload>
            </div>
            <div class="card-back">
              <div class="preview-box" v-if="personalVerso.url">
                <img class="avatar" :src="personalVerso.url" />
                <div class="img-box">
                  <i
                    style="color:#fff"
                    class="el-icon-delete-solid delete-sty"
                    @click="delBackImg('back')"
                  ></i>
                </div>
              </div>
              <el-upload
                v-if="!personalVerso.url"
                action="#"
                :show-file-list="false"
                :on-success="
                  (response, file, fileList) =>
                    handleIdeCareSuccess(
                      response,
                      file,
                      fileList,
                      'personalVerso'
                    )
                "
                :before-upload="
                  file => beforeIdeCareUpload(file, 'personalVerso')
                "
              >
                <div>
                  <div class="card-item back">
                    <i
                      class="el-icon-plus avatar-uploader-icon"
                      style="font-size:3vw;color:#C2C2C2"
                    ></i>
                    <p class="upload-tit">国徽面</p>
                  </div>
                </div>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="姓名：" prop="idName">
          <!-- v-show="personalFront.url" -->
          <el-input style="width:20vw" v-model="cardFace.idName"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idNo">
          <!--  v-show="personalFront.url" -->
          <el-input
            style="width:20vw"
            v-model="cardFace.idNo"
            :maxlength="18"
            show-word-limit
          >
            <!-- <i
              slot="suffix"
              class="el-input__icon el-icon-full-screen suffix-sty"
              @click="UPByPhone"
            ></i> -->
<!--            <img-->
<!--              slot="suffix"-->
<!--              src="/images/icon/ocr.png"-->
<!--              alt="上传证件扫描"-->
<!--              @click="UPByPhone"-->
<!--            />-->
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 接口
import {
  postFileTempUpload,
  fileOperShowParam2Str,
  ApiMethods
} from "@/assets/js/http-serve/http-methods";
//
import GlobalConfig from "@/assets/js/config/global";
import Qrcode from "qrcode.vue";
import { certTypes } from "@/assets/js/utils/typesTool";
import qs from "qs";

export default {
  props: { backUrl: String,APIAUTHINFO:Object, authStep:{type:Number,default:1}},
  data() {
    return {
      // 展示可选项
      isShow: true,
      getInter: "",
      byPhoneUrl: "",
      // 身份证人像面
      personalFront: {
        url: "",
        targetId: ""
      },
      // 身份证国徽面
      personalVerso: {
        url: "",
        targetId: ""
      },
      cardFace: {
        idName: "",
        idNo: ""
      },
      faceFrmRules: {
        url: [
          {
            validator: this.IDCARD,
            trigger: "change",
            message: "请传入身份证照片"
          },
        ],
        idName: [
          { required: true, message: "真实姓名不能为空", trigger: "blur" },
          {
            validator: this.$validator.specialVal,
            trigger: "change",
            message: "真实姓名不能包含特殊字符"
          },
          {
            validator: this.$validator.lengthRank,
            trigger: "change",
            minLength: 2,
            maxLength: 20
          }
        ],
        idNo: [
          { required: true, message: "身份证不能为空", trigger: "blur" },
          { validator: this.$validator.idCard, trigger: ["change", "blur"] }
        ]
      },
      // 接口
      authApi: ApiMethods.IdenAuthController
    };
  },
  methods: {
    IDCARD(value, rule, callback){
      const {url:FaceUrl,targetId:FaceTID} = this.personalFront,{url:VersoUrl,targetId:VerTID} = this.personalVerso;
      if((FaceUrl && FaceTID) && (VersoUrl && VerTID)){
        callback();
      }else if (!(FaceUrl && FaceTID)) {
        callback(new Error("请上传身份证人像面"));
      }else if (!(VersoUrl && VerTID)) {
        callback(new Error("请上传身份证国徽面"));
      } else{
        callback(new Error("请上传身份证照片"));
      }
    },
    delBackImg(type) {
      if (type === "face") {
        // 身份证人像面
        this.personalFront = {
          url: "",
          targetId: ""
        };
      } else {
        // 身份证国徽面
        this.personalVerso = {
          url: "",
          targetId: ""
        };
      }
    },
    /** 手机上传获取签名显示二维码 */
    UPByPhone() {
      this.authApi.getUploadUrl().then(res => {
        if (!res.success) {
          return this.$message.error(res.description);
        }
        const { data } = res;
        this.byPhoneUrl = `${GlobalConfig.domain.junziqianH5Op}/auth/scanningCodeUpload?sign=${data.sign}&uploadKey=${data.uploadKey}&ts=${data.ts}&uploadType=${certTypes.IDCard}`;
        console.log("url", this.byPhoneUrl);
        setTimeout(() => {
          this.getFile(data);
        }, 3 * 1000);
      });
    },
    getFile(param) {
      this.getInter = setInterval(() => {
        if(this.authStep === 2) return clearInterval(this.getInter)
        ApiMethods.IdenAuthController.getUploadData(param).then(res => {
          if (!res.success) {
            return this.$message.error(res.description);
          }
          const haveRes = Object.keys(res.data);
          if (haveRes.length >= 2) {
            // 上传成功并提示
            this.isShow = true;
            this.$message.success("上传成功，正在识别中请稍后...");
            clearInterval(this.getInter);
            this.getInter = "";
            // [key] 1 是人像面 0 非人像面
            this.personalFront.targetId = res.data[1].targetId;
            this.personalFront.url = fileOperShowParam2Str(
              qs.stringify(res.data[1])
            );
            this.personalVerso.targetId = res.data[0].targetId;
            this.personalVerso.url = fileOperShowParam2Str(
              qs.stringify(res.data[0])
            );
            this.IDCardOCR({
              file: res.data[1].targetId,
              name: "personalFront"
            });
          }
        });
      }, 2 * 1000);
    },
    // 验证数据
    async checkCard() {
      const { personalFront: card_face, personalVerso: card_back } = this;
      return new Promise((resolve, reject) => {
        // if (!(card_face.url && card_face.targetId)) {
        //   this.$message.error("请上传身份证人像面");
        //   resolve(false);
        // } else if (!(card_back.url && card_back.targetId)) {
        //   this.$message.error("请上传身份证国徽面");
        //   resolve(false);
        // }
        this.$refs.cardFace.validate(async vaild => {
          console.log("vaild", vaild);
          if (vaild) {
            const cardInfo = {
              card_face,
              card_back,
              ...this.cardFace
            };
            resolve(cardInfo);
          } else {
            resolve(false);
          }
        });
      });

      // if (!(this.cardFace.idName && this.cardFace.idNo)) {
      //   this.$message.error(
      //     "请填写正确的身份信息，或者重新上传身份证人像面图片"
      //   );
      //   return false;
      // }
    },
    /** ocr身份证识别 */
    IDCardOCR(params) {
      const { file, name } = params;
      // 身份证正面(人像面) name == "personalFront"
      const card = {
        file,
        front: name == "personalFront" ? 1 : 0,
        multiSignatoryKey:this.$route.query.multiSignatoryKey
      };
      this.authApi
        .ocrIdCard(card)
        .then(res => {
          if (res.success) {
            if (name == "personalFront") {
              this.cardFace = res.data;
            }
          } else {
            if(respon.code == "10807") return this.$message.error('识别不成功（代码：23)');
            this.$message.error("识别失败，请重新拍摄图片并上传。");
          }
        })
        .finally(() => {
          this.$emit("loadingClose");
        });
    },
    noContinent() {
      this.$emit("update:isContinent", false);
    },
    handleIdeCareSuccess(res, file, list, name) {
      this[name].url = URL.createObjectURL(file.raw);
    },
    beforeIdeCareUpload(file, name) {
      const re = new RegExp("(.jpg|.png|.jpeg)$", "i");
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!re.test(file.name)) {
        this.$message.error("文件格式只能是jpg/png/jpeg的文件");
        return false;
      }
      if (!isLt20M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return false;
      }
      this.$emit("loadingStart", "文件上传中~");
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this[name].targetId = data.tempFile.targetId;
          if (name == "personalFront") {
            this.IDCardOCR({ file: data.tempFile.targetId, name });
          } else {
            this.$emit("loadingClose");
          }
        })
        .catch(err => {
          this.$emit("loadingClose");
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    handleShowUpload() {
      this.isShow = !this.isShow;
      this.UPByPhone();
      if (!this.isShow) {
        // this.delBackImg("face");
        // this.delBackImg();
        // this.$set(this.personalFront,'url','')
        // this.$set(this.personalVerso,'url','')
      }
    }
  },
  components: { Qrcode },
  mounted() {
    this.UPByPhone()
  },
  beforeDestroy(){
    if(this.getInter) clearInterval(this.getInter)
  },
  watch:{
    APIAUTHINFO:{
      handler(val){
        const { backUrl, identityCard, name,identityFrontImgFile:IDface,identityBackImgFile:IDback } = val,
          form = this.cardFace;
        this.$emit("update:backUrl", backUrl);
        form.idNo = identityCard;
        form.idName = name;

        // 身份证人像面
        if(IDface && Object.keys(IDface).length > 0){
          this.personalFront.targetId = IDface.targetId;
          this.personalFront.url = fileOperShowParam2Str(
            qs.stringify(IDface)
          );
          // bug编号【8949】，回显图片不调用ocr
          // this.IDCardOCR({
          //   file: IDface.targetId,
          //   name: "personalFront"
          // });
        }
        // 身份证国徽面
        if(IDback && Object.keys(IDback).length > 0){
          this.personalVerso.targetId = IDback.targetId;
          this.personalVerso.url = fileOperShowParam2Str(
            qs.stringify(IDback)
          );
        }
      },
      immediate:true
    }
  }
};
</script>

<style scoped lang="less">
.doc-box {
  position: relative;
  .img-box {
    display: none;
    position: absolute;
    top: 0;
    .delete-sty {
      font-size: 30px;
      cursor: pointer;
    }
  }
  &:hover {
    .img-box {
      width: 280px;
      height: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ccc;
      opacity: 0.5;
    }
  }
}
.face-card-box {
  display: flex;
  justify-content: flex-start;
  > p {
    margin-right: 40px;
    color: #606266;
  }
}
.suffix-sty {
  font-size: 25px;
  color: #ec1c1e;
  cursor: pointer;
}
.dialog-body {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tips {
  padding: 10px;
  margin: 15px auto;
  padding-left: 40px;
  background-color: #fef7f7;
  color: #777777;
  font-size: 14px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
}
.info-box {
  padding: 10px;
  border: 1px solid #e5e5e5;
  .id-type {
    display: flex;
    justify-content: space-between;
  }
  .can-be-show {
    display: inline-block;
    margin-left: 150px;
    margin-bottom: 22px;
    cursor: pointer;
    color:#E3241D;
  }
  .card-box {
    width: 20vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .card-face {
      display: flex;
      // align-items: center;
      // margin: 10px 0 20px 0;
    }
    .card-back {
      margin-left: 10px;
      display: flex;
      .back {
        background-image: url("/images/auth/authIcon/backAdd.png") !important;
      }
    }
    .preview-box {
      width: 180px;
      height: 115px;
      position: relative;
      &:hover .img-box {
        opacity: 1;
      }
      .card-img {
        margin-left: 0;
      }
      .img-box {
        opacity: 0;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    .card-item {
      width: 180px;
      height: 115px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-image: url("/images/auth/authIcon/faceAdd.png");
      background-size: cover;
      &.back {
        margin-left: 10px;
      }
    }
    .avatar {
      width: 180px;
      height: 115px;
    }
    .card-img {
      width: 180px;
      height: 115px;
      margin-left: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/auth/APIAuth/justRegister/components/mainland.vue